import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import {
  CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS,
  LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS,
  SAVE_SANTANDER_DOMICILED_COLLECTION_OPTIONS
} from 'src/store/actions/santanderDomiciledCollectionActions';

const initialState = {
  items: [],
  count: 0,
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0,
    startDate: momentLocalTimezone()
      .isoWeekday(1)
      .startOf('day')
      .toDate(),
    endDate: momentLocalTimezone()
      .isoWeekday(7)
      .endOf('day')
      .toDate()
  }
};

const santanderDomiciledCollectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.start:
      return state;
    case LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.success:
      return {
        ...state,
        items: action.data.items || [],
        count: action.data.count || 0
      };
    case LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.failure:
      return state;
    case SAVE_SANTANDER_DOMICILED_COLLECTION_OPTIONS:
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    case CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS:
      return {
        ...state,
        options: initialState.options
      };
    default:
      return state;
  }
};

export default santanderDomiciledCollectionReducer;
